import React from "react"
import "./App.css"
import Content from "./components/Content"
import Footer from "./components/Footer"

function App() {
  return (
    <div className="App">
      <Content/>
      <Footer/>
    </div>
  )
}

export default App
